import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import { ActionStatus, FormStatus } from '../types';

type GetFormStatus = {
  status: ActionStatus;
  createAddressView: boolean;
  showDeliveryAddresses: boolean;
  addressBeingEdited: boolean;
};
const getFormStatus = ({
  status,
  createAddressView,
  showDeliveryAddresses,
  addressBeingEdited,
}: GetFormStatus) => {
  const formStatus = FormStatus.Select;

  if (status === ActionStatus.QUOTE_UNAVAILABLE && showDeliveryAddresses) {
    return FormStatus.Unavailable;
  }
  if (createAddressView || !showDeliveryAddresses) {
    return addressBeingEdited ? FormStatus.Edit : FormStatus.Add;
  }

  return formStatus;
};

export const useHeaderTitle = ({
  status,
  createAddressView,
  showDeliveryAddresses,
  addressBeingEdited,
  showTermsView,
}: GetFormStatus & {
  status: ActionStatus;
  createAddressView: boolean;
  showDeliveryAddresses: boolean;
  addressBeingEdited: boolean;
  showTermsView: boolean;
}) => {
  const { formatMessage } = useIntl();

  return useMemo(() => {
    const formStatus = getFormStatus({
      status,
      addressBeingEdited,
      showDeliveryAddresses,
      createAddressView,
    });

    if (showTermsView) {
      return formatMessage({ id: 'deliveryTermsHeading', defaultMessage: 'Delivery Terms' });
    }

    if (formStatus === FormStatus.Unavailable) {
      return formatMessage({ id: 'deliveryNotAvailable' });
    }

    if (formStatus === FormStatus.Edit) {
      return formatMessage({ id: 'editAddress', defaultMessage: 'Edit Address' });
    }

    if (formStatus === FormStatus.Add) {
      return formatMessage({ id: 'deliveryAddNewAddress', defaultMessage: 'Add new address' });
    }

    return formatMessage({
      id: 'deliverySelectYourAddress',
      defaultMessage: 'Select your delivery address',
    });
  }, [
    addressBeingEdited,
    createAddressView,
    formatMessage,
    showDeliveryAddresses,
    showTermsView,
    status,
  ]);
};
